module.exports = __webpack_public_path__ + "static/media/downScrollingIcon.43dbc438.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downScrollingIcon.svg
// module id = 90
// module chunks = 0